import React from 'react';
import PropTypes from 'prop-types';

import { LABEL_SIZE_XXLARGE, LABEL_SIZE_XLARGE, LABEL_SIZE_LARGE, LABEL_SIZE_REGULAR, LABEL_SIZE_SMALL } from 'utils/constants';

import FormLabel from 'components/FormLabel/FormLabel';

import { StyledFormItem } from './FormItem.styles';

const addRules = (hasRequiredErrorMessage, requiredErrorMessage, extraRules) => {
  const rules = [];

  if (hasRequiredErrorMessage) {
    rules.push({
      required: true,
      message: requiredErrorMessage
    });
  }

  return [...rules, ...extraRules];
};

const FormItem = ({
  name,
  defaultValue,
  requiredErrorMessage,
  extraRules,
  label,
  labelSize,
  labelClassName,
  formLabel,
  className,
  children,
  uppercase,
  ...props
}) => {
  const hasRequiredErrorMessage = requiredErrorMessage && typeof requiredErrorMessage === 'string';
  const rules = addRules(hasRequiredErrorMessage, requiredErrorMessage, extraRules);
  const normalize = value => (uppercase ? (value || '').toUpperCase() : value);

  return (
    <div className={className}>
      {!formLabel && !!label && (
        <FormLabel labelSize={labelSize} className={labelClassName} hasRequiredErrorMessage={hasRequiredErrorMessage} {...props}>
          {label}
        </FormLabel>
      )}
      <StyledFormItem name={name} label={formLabel} colon={false} rules={rules} normalize={normalize}>
        {children}
      </StyledFormItem>
    </div>
  );
};

FormItem.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  requiredErrorMessage: PropTypes.string,
  extraRules: PropTypes.array,
  label: PropTypes.string,
  labelSize: PropTypes.oneOf([LABEL_SIZE_XXLARGE, LABEL_SIZE_XLARGE, LABEL_SIZE_LARGE, LABEL_SIZE_REGULAR, LABEL_SIZE_SMALL, '']),
  labelClassName: PropTypes.string,
  formLabel: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

FormItem.defaultProps = {
  requiredErrorMessage: '',
  extraRules: [],
  label: '',
  labelSize: '',
  labelClassName: '',
  formLabel: '',
  className: ''
};

export default FormItem;
